import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

const ConsentFormFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={s.footer}>
      <b className={s.title}>
        200 South 10th Street McAllen, Suite 103, TX, 78501{' '}
        {t('labels.phoneNumber')}: (888) 407-4108・ {t('labels.fax')}: (956) 202
        -0260
      </b>

      <b>
        <a href="https://accuhealth.tech">www.accuhealth.tech</a>{' '}
        {t('dates.monday')} - {t('dates.friday')} 8:00 A.M. - 5:00 P.M.・On-call
        24 hours
      </b>
    </div>
  );
};

export default ConsentFormFooter;
